import { AttachFilePopoverStyled } from 'modules/PopoverAttachment.styled'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'

export const PurchaseHistoryListSectionStyled = styled(Container)`
  .link-history {
    color: ${({ theme }) => theme.colors.linkColorLight};
    &:hover {
      text-decoration: underline;
    }
  }

  .error-banner {
    padding: 1rem;
    margin-bottom: 1rem;
    background-color: ${({ theme }) => theme.colors.ribbonDangerBackgroundColor};
    color: ${({ theme }) => theme.colors.dangerColor};
    border-radius: 0.25rem;
    font-size: 1.3rem;
  }

  .table-container {
    border-radius: 8px;
    border: none;
    box-shadow: 0px 2px 4px 1px #ccc;
  }

  .purchase-history-table {
    color: #555;

    thead th {
      font-weight: normal;
      text-transform: uppercase;
      font-size: 1.5rem;
      padding-top: 8px;
      padding-bottom: 5px;
      vertical-align: middle;
      border: none;
    }

    tbody tr td {
      min-height: 5rem;
      vertical-align: middle;
      font-size: 1.5rem;
      border-top-color: #e3e4e5;
    }

    tr.table-row:nth-child(even) {
      background: ${({ theme }) => theme.colors.tableStriped ?? '#f9f9f9'};
    }
    tr.table-row:nth-child(odd) {
      background-color: #fff;
    }

    tbody tr:hover {
      background-color: ${({ theme }) => theme.colors.sectionContentBackgroundColor};
    }

    tr.expanded-row td {
      background-color: #f6f6f6;
      min-height: 5rem;
      padding: 1rem;
    }
  }

  .documents {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
  }

  .document-arbitration-link {
    background: none;
    border: 0;
    padding: 0;
    margin: 0;
    font: inherit;
    font-size: 1.5rem;
    text-align: left;
    text-transform: uppercase;
    cursor: pointer;

    &:disabled {
      color: inherit;
      cursor: default;
      opacity: 1;
      text-decoration: none;
      font-weight: 400;
    }
  }

  .arbitration-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
  }

  .arbitration-label {
    font-size: 1.5rem;
    font-weight: 400;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.headerFontColor};
  }

  .arbitration-submitted {
    color: #2e7d32;
  }

  .arbitration-status {
    color: ${({ theme }) => theme.colors.headerFontColor};
  }

  .arbitration-expired {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    white-space: nowrap;
  }

  .arbitration-expired-icon {
    font-size: 1.4rem;
    cursor: pointer;
  }

  .charges-link {
    font-size: 1.5rem;
  }

  .price-str {
    font-size: 1.5rem !important;
    color: black !important;
  }
`

export const AdditionalChargesPopover = styled(AttachFilePopoverStyled)`
  font-size: 1.6rem;
  .popover-header {
    padding-left: 1.9rem;
  }
  .charges-content {
    display: flex;
    justify-content: space-between;
  }
  .description {
    padding-left: 0.9rem;
    font-weight: 600;
  }

  .price-string {
    padding-right: 0.9rem;
    display: flex;
    align-items: flex-end;
  }
`
